﻿export default interface ARFData {
    submitDate: Date;
    requesterType: RequesterTypes;
    producerName: string;
    carrierName: string;
    containerNum: string;
    equipmentType: string;

    reqName: string;
    reqPhone: string;
    reqEmailAddress: string;

    detailLines: ASNListLine[];

    totalPallets: number,
    totalCases: number,
    prefApptDate: Date | null,
    prefApptTime: string,
    comments: string
}

export interface ASNListLine {
    asnNo: string;
    cases: number;
}

export enum RequesterTypes {
    Agency = 0,
    FreightForwarder = 1
}

export const EquipmentTypes = ["Passenger Vehicle", "Courier", "Carrier"];
export const AppointmentTimeslots = ["7am - 9am", "9am - 11am", "11am - 1pm", "1pm - 3pm"];